export const defaultFormat = 'dd/MM/yyyy';
export const StringFormat = 'dd MMMM yyyy';
export const dateAndTime = 'dd MMMM yyyy | hh:mm';
export const dateAndTimeShort = 'dd MMM yyyy | hh:mm';
export const dateShort = 'MMM dd, yyyy';
export const timeShort = 'HH:mm';
export const dateShort2 = 'MMM dd';
